/**
 * The FSMOps imagotype (mark + wordmark).
 *
 * The asset already contains the product name, so it is decorative wherever a
 * heading repeats it — callers pass `alt=""` in that case to avoid a screen
 * reader announcing "FSMOps" twice.
 */
export default function Logo({
  className,
  alt = 'FSMOps',
}: {
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src="/fsm_imagotipo.png"
      alt={alt}
      // Square source; height is set by the caller and width follows.
      className={`h-8 w-auto object-contain ${className ?? ''}`}
    />
  );
}
